/**
 * Executes Google reCAPTCHA v3 and returns the token.
 * Can be reused across any form (contact, comments, bookings, etc.)
 *
 * @param action - A specific action name for tracking in Google Admin Console (e.g., 'contact_form').
 * @returns A promise resolving to the reCAPTCHA token (or empty string if disabled).
 */
export const executeRecaptcha = async (action: string): Promise<string> => {
  const siteKey = (window as any).commonVariables?.recaptchaSiteKey;

  // If site key is not configured in WP Admin, bypass validation silently.
  if (!siteKey) {
    return "";
  }

  // Ensure Google's grecaptcha object is loaded
  if (typeof (window as any).grecaptcha === "undefined") {
    console.warn("reCAPTCHA script is not loaded.");
    return "";
  }

  return new Promise((resolve) => {
    (window as any).grecaptcha.ready(() => {
      (window as any).grecaptcha
        .execute(siteKey, { action })
        .then((token: string) => {
          resolve(token);
        })
        .catch((err: any) => {
          console.error("reCAPTCHA Execution Error:", err);
          resolve(""); // Fallback gracefully
        });
    });
  });
};
